/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface InstallDbConfig { 
    /**
     * Flag to indicate whether Install Case has been created successfully during Activation
     */
    activated?: boolean;
}

